import { Dialog, DialogContent } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Axios from 'axios';
import { useSelector } from "react-redux";

const subscriptionPlans = [
    {
        image: "https://clientwiseportal.com/wp-content/uploads/2022/08/owl-icon-1.png",
        title: "Starter",
        price: 0,
        description: "For those getting started and learning Clientwise.",
        stripe_key: "price_1QoNB5ChLtarUozxc431d3fF",
        features:[
            'Up to 3 Users',
            'Up to 500MB Storage',
            'Secure Client Data and Document Intake',
            'Encrypted Document Storage & Sharing',
            'Estate Spreadsheets & Calculation Tools',
            'Interactive Timelines & Sharing'
        ]
    },
    {
        image: "https://clientwiseportal.com/wp-content/uploads/2022/08/owl-icon-2.png",
        title: "Basic",
        price: 9900,
        description: "For small legal teams requiring a relatively small amount of data storage. Upgrade or downgrade at any time.",
        stripe_key: "price_1LgzVGChLtarUozxSmAFcDXR",
        features:[
            'Up to 4 Users',
            'Up to 2GB Storage',
            'Secure Client Data and Document Intake',
            'Encrypted Document Storage & Sharing',
            'Estate Spreadsheets & Calculation Tools',
            'Interactive Timelines & Sharing',
            'Client Budgeting & Calculation Tools'
        ]
    },
    {
        image: "https://clientwiseportal.com/wp-content/uploads/2022/08/owl-icon-2.png",
        title: "Standard",
        price: 12900,
        description: "For medium sized legal teams or teams requiring more data storage. Upgrade or downgrade at any time.",
        stripe_key: "price_1LgzVQChLtarUozxwicySept",
        features:[
            'Up to 8 Users',
            'Up to 10GB Storage',
            'Secure Client Data and Document Intake',
            'Encrypted Document Storage & Sharing',
            'Estate Spreadsheets & Calculation Tools',
            'Interactive Timelines & Sharing',
            'Client Budgeting & Calculation Tools'
        ]
    },
    {
        image: "https://clientwiseportal.com/wp-content/uploads/2022/08/owl-icon-3.png",
        title: "Premium",
        price: 16900,
        description: "For larger teams or firms that require unlimited data storage and flexibility. Downgrade at any time.",
        stripe_key: "price_1LgzVaChLtarUozxpNROLlxD",
        features:[
            'Unlimited Users',
            'Unlimited Storage',
            'Secure Client Data and Document Intake',
            'Encrypted Document Storage & Sharing',
            'Estate Spreadsheets & Calculation Tools',
            'Interactive Timelines & Sharing',
            'Client Budgeting & Calculation Tools'
        ]
    },
];

export default function ChangePlan({subscription}){
    const [open, setOpen] = useState(false);
    const {subscription_details} = useSelector(state => state.subscriptionData?.subscriptionData?.original);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);
    
    const handleModalState = () => {
        setOpen(!open);
    };
    
    const isCurrentSubscription = (plan) => {
        if(subscription?.subscription_price ===  plan.price){
            return true;
        }
        return false;
    };
    
    const getButtonText = (plan) => {
        if(isCurrentSubscription(plan)) return `This is your current plan.`;
        if(subscription?.subscription_price < plan.price){
            return `Upgrade to ${plan.title}`;
        }
        return `Downgrade to ${plan.title}`;
    };
    
    const handleUpdateSubscription = async (stripe_key) => {
        setSubmitting(true);
        const dataBuilder = {
            subscription_id: subscription_details?.subscription_id,
            price_id: stripe_key
        };
        await Axios.post(`/api/v2/subscriptions/update`,dataBuilder)
        .then(() => {
            window.location.reload();
        })
        .catch((err) => {
            setError(err.response.data.message);
        })
        .finally(() => {
            setSubmitting(false);
        });
    };
    
    useEffect(() => {
        if(error){
            setTimeout(() => {
                setError(null);
            }, 3000);
        }
    }, [error]);
    
    return(
        <>
        <button
            type="button"
            className="btn btn-light-primary font-weight-bold btn-sm"
            onClick={handleModalState}
        >
            Change Plan
        </button>
        <Dialog open={open} fullWidth maxWidth="lg" onClose={handleModalState}>
            <DialogContent className="p-5 d-flex flex-column">
                {error && <h2 className="text-danger text-center">{error}</h2>}
                <div className="d-flex flex-column flex-md-row">
                    {subscriptionPlans.map(plan => (
                        <div key={plan.price} className="col-md-3 col-sm-12 p-2 pb-3 ">
                            <div className="card d-flex flex-column align-items-center p-2 h-100 border-0 shadow-sm rounded-lg">
                                <img src={plan.image} alt={plan.title} className="img-fluid" style={{width: "80px", height: "80px"}} />
                                <h2 className="m-0">{plan.title}</h2>
                                <h5 className="m-0 font-weight-bolder mt-5">
                                    ${plan.price !== null && plan.price !== undefined ? String(plan.price).slice(0, -2) : 0}
                                    {plan.price === 0 ? '0/month' : '/month'}
                                </h5>
                                <p className="mt-3 mb-5 text-center" style={{height: "70px"}}>
                                    {plan.description}
                                </p>
                                <ul className="mt-4">
                                    {plan.features.map(feature => (
                                        <li key={crypto.randomUUID()}>{feature}</li>
                                    ))}
                                </ul>
                                <button
                                    type="button"
                                    className={`mt-auto btn font-weight-bold btn-sm ${isCurrentSubscription(plan) ? 'current-subscription-button' : 'btn-light-primary'}`}
                                    onClick={() => handleUpdateSubscription(plan.stripe_key)}
                                    disabled={isCurrentSubscription(plan) || submitting}
                                >
                                    {submitting && <div className="spinner-border spinner-border-sm"></div>}
                                    {!submitting && getButtonText(plan)}
                                </button>
                            </div>
                        </div>
                    ))}
                    
                </div>
            </DialogContent>
        </Dialog>
        </>
    );
};